import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  animation: ShadeIn 0.7s linear;
  @keyframes ShadeIn {
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
`;

export const Part = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const ButtonsBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  width: 100%;

  > a,
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 145px;
    margin-top: 25px;
    color: #592c82;
    cursor: pointer;
    text-decoration: none;
  }

  @media (max-width: 810px) {
    height: 64px;
    padding: 0 0.25rem;
  }
`;

export const HeaderWelcome = styled.div`
  text-align: center;
  margin-bottom: 30px;
  > h4 {
    color: #592c82;
    margin: 0;
    font-size: 22px;
  }
  > span {
    color: #b1a3a3;
  }
`;

export const Account = styled.a`
  font: ${(props) => props.theme.fonts.CreateAccount};
`;

export const ForgotPassword = styled.div`
  font: ${(props) => props.theme.fonts.CreateAccount};
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent linear-gradient(180deg, #7c2280 0%, #2d1641 100%) 0%
    0% no-repeat padding-box;
  > img {
    padding: 20px;
    width: 250px;
  }
`;

export const ContainerCard = styled.div`
  width: 450px;
  @media (max-width: 768px) {
    width: 350px;
  }
  @media (max-width: 425px) {
    width: 300px;
  }
`;
